import { React, useEffect, useState,createContext } from "react";
import { AgGridReact } from "ag-grid-react"; // the AG Grid React Component
import styled from "styled-components";
import "ag-grid-community/styles/ag-grid.css"; // Core grid CSS, always needed
import "ag-grid-community/styles/ag-theme-alpine.css"; // Optional theme CSS
import Site from "../bootstrap/Site";
import { getAuthToken } from "../api/api";
import { getAPIUrl, notify, suppressKeyboardEvent } from "../components/common/helpers";
import { getUserDetails } from "../components/sidebar/Sidenav";
import CustomDetailsComponent from "../components/common/CustomDetailsComponent";
import { ToastContainer } from "react-toastify";
import { SiteDetailsCellRenderer } from "../components/common/CustomCellRenderer";
import "react-toastify/dist/ReactToastify.css";
import axios from "axios";
import EmailConfiguration from "../bootstrap/EmailConfig";

const StyledSiteDetails = styled.div`
  .Deletebtn {
    background: transparent;
    border: none;
    color: white;
  }
  .Deletebtn:hover {
    background: transparent;
    border: none;
  }
  .Deletebtn:disabled {
    cursor: not-allowed;
    pointer-events: auto;
  }
`;
const SiteContext = createContext();

export default function SiteDetails(props) {
  const { disabledFeatures } = props;
  const [tableData, setTableData] = useState();
  const [edit, setEdit] = useState(false);
  const [recordValues, setRecordValues] = useState();
  const [readOnly, setReadOnly] = useState(false);
  const [gridEntries, setGridEntries] = useState();
  const [title, setTitle] = useState("");
  const [gridApi, setGridApi] = useState(null);


  const controller = new AbortController();

  const onGridReady = (params) => {
    setGridApi(params.api);
  };

  const handleDeleteSite = (field) => {
    const { site_id, building_name } = field;
    const msg = `Are you sure, you want to delete ${building_name}`;
    const confirm = window.confirm(msg);
    if (confirm) {
      const body = JSON.stringify({
        site_id,
        title: "SiteManagement",
        updated_by: getUserDetails().username,
      });
      axios({
        method: "PATCH",
        url: getAPIUrl("deleteFunctionApi"),
        headers: { Authorization: getAuthToken()},
        signal: controller.signal,
        data: body
      })
        .then((resp) => {
          if (resp) {
            getSiteDetails();
          }
        })
        .catch((error) => {
          console.log(error);
        });
    }
  };

  const handleEdit = (field) => {
    setEdit(true);
    setRecordValues(field);
  };

  const handleSiteDetails = (field) => {
    setReadOnly(true);
    setGridEntries(field);
    setTitle(`Details of Site - ${field.building_name}`);
  }

  const handleDownloadNetworkDiagram = async (field) => {
    const {site_id, network_digram_path} = field;
    try {
      axios({
        method: "GET",
        url: getAPIUrl("getNetworkDiagram")+`?site_id=${site_id}`,
        headers: { Authorization: getAuthToken() },
        signal: controller.signal,
      })
      .then(async (resp) => {
        if (resp.status === 200) {
            const fileLink = resp.data;
            try {
              const url = new URL(fileLink);
             const fileResponse = await fetch(url.toString());
          if (!fileResponse.ok) {
                  throw new Error('Failed to fetch file');
                }
                alert("Download Initiated");
                const blob = await fileResponse.blob();
                const downloadUrl = window.URL.createObjectURL(blob);
                const link = document.createElement('a');
                link.href = downloadUrl;
                link.download = network_digram_path;
                document.body.appendChild(link);
                link.click();
                document.body.removeChild(link);
                window.URL.revokeObjectURL(downloadUrl);            
            } catch (err) {
              console.error('Invalid or untrusted URL:', err);
            }
          }
      })
      .catch((err) => {
        err.message !== "canceled" && notify("downloading");
      });
    } catch (error) {
     console.log(error)
    }
  }

  const column = [
    {
      headerName: "Site Name",
      field: "building_name",
      floatingFilter: true,
    },
    {
      headerName: "Customer EmailId",
      field: "customer_email_id",
      floatingFilter: true,
    },
    {
      headerName: "Field Team EmailId",
      field: "field_team_email_id",
      floatingFilter: true,
    },
    {
      headerName: "Country",
      field: "bulding_country",
      floatingFilter: true,
    },
    {
      headerName: "Site Address",
      field: "building_address",
      floatingFilter: true,
    },
    {
      headerName: "City",
      field: "bulding_city",
      floatingFilter: true,
    },

    {
      headerName: "State",
      field: "building_state",
      floatingFilter: true,
    },
    {
      headerName: "Customer Name",
      field: "customer_name",
      floatingFilter: true,
    },
    {
      headerName: "Details",
      colId: "details",
      minWidth: 100,
      cellRenderer: SiteDetailsCellRenderer,
      cellRendererParams: {
       type : "info",
       handleSiteDetails
      }
    },
     {
          headerName: "Network Diagram",
          colId: "network_diagram",
          flex: 1,
          minWidth: 100,
          cellRenderer: SiteDetailsCellRenderer,
          cellRendererParams: {
           type : "network_diagram",
           handleDownloadNetworkDiagram
          }
        },
    {
      headerName: "Action",
      hide: disabledFeatures.includes("AddSite"),
      field: "site_id",
      colId: "action",
      cellRenderer: SiteDetailsCellRenderer,
      cellRendererParams: {
       type : "edit",
       disabledFeatures,
       handleEdit,
       handleDeleteSite
      }
    },
  ];
  const defaultColDef = {
    sortable: true,
    editable: true,
    filter: true,
    flex: 1,
    resizable: true,
    minWidth: 110,
    suppressKeyboardEvent,
  };

  const requiredKeys = {
    component_types: "Component Types",
    created_date: "Created Date", 
    created_by: "Created By",
    updated_by : "Updated By",
    updated_date : "Updated Date",
    site_id:"Site Id"
    };

    const createServerRequest = (params) => {
      const {startRow, endRow, filterModel, sortModel} = params;
      let sortQuery = '';
      let filterParams = '';
      if (sortModel && sortModel.length > 0 && sortModel !== undefined) {
       sortQuery = `&sortColumn=${sortModel[0].colId}&sortOrder=${sortModel[0].sort}`;
      }
      if (Object.keys(filterModel).length > 0) {
       filterParams = Object.keys(filterModel).map(field => {
         const filter = filterModel[field];
         return `&${field}=${filter.filter}`
       }).join('');
      }
      return `?filter_page=${startRow}&filter_pageSize=${endRow}${filterParams}${sortQuery}`;
  }

  const showErrorOverlay = (gridApi) => {
    if (gridApi) {
      gridApi.showNoRowsOverlay();
    }
  };

  const handleApiError = (gridApi) => {
      showErrorOverlay(gridApi);
  };


    useEffect(() => {
      if(gridApi) {
        getSiteDetails();
      }
     }, [gridApi]);

  const getSiteDetails = async () => {
    if(!gridApi) return;
    const dataSource = {
      getRows: (params) => {
        const requestParameters = createServerRequest(params);
        gridApi.showLoadingOverlay();
        axios({
          method: "GET",
          url:
            getAPIUrl("getSiteDetailsApi") + requestParameters,
          headers: {
            Authorization: getAuthToken(),
          },
          signal: controller.signal,
        })
        .then((res) => {
          if (res && res.data.siteDetails.length > 0) {
            const responseData = res.data.siteDetails.map((item) => ({
              ...item
            }));
            params.successCallback(responseData,  res.data.lastRow);
            gridApi.hideOverlay();
          } 
          else {
            params.successCallback([], 0);
            handleApiError(gridApi);
          }
        })
        .catch((err) => {
          console.log(err);
          params.successCallback([],  0);
          params.failCallback();
          handleApiError(gridApi);
          err.message !== "canceled" && notify("fetching");
        });
    }
  }
    gridApi.setDatasource(dataSource);
  };

  // calling getSiteDetails function for first time
  useEffect(() => {
    document.title = "Site Details";
    getSiteDetails();

    return () => {
      controller.abort();
    };
  }, []);

  return (
    <StyledSiteDetails>
      <h4 className="text-white p-2">Site Details</h4>
      <div
        className="container-fluid"
        style={{
          background: "#1F1F1F 0% 0% no-repeat padding-box",
          border: "1px solid #707070",
          width: "100%",
        }}
      >
        <div className="text-end py-2">
          <EmailConfiguration
          disabledFeatures={disabledFeatures}
            getSiteDetails={getSiteDetails}
            isEdit={false}>
            </EmailConfiguration>
          <Site
            disabledFeatures={disabledFeatures}
            getSiteDetails={getSiteDetails}
            isEdit={false}
          />
        </div>
        <div className="text-end py-2">
            {readOnly && <CustomDetailsComponent 
            gridEntries= {gridEntries}
            readOnly = {readOnly}
            setReadOnly= {setReadOnly}
            requiredKeys= {requiredKeys}
            title ={title}
              /> }
        </div>
        <div
          className="ag-theme-alpine-dark"
          style={{ height: 545, width: "100%" }}
        >
          {edit && (
            <Site
              disabledFeatures={disabledFeatures}
              getSiteDetails={getSiteDetails}
              isEdit={edit}
              setEdit={setEdit}
              rowEntries={recordValues}
            />
          )}
          <AgGridReact
            onGridReady={onGridReady}
            rowModelType={"infinite"}
            columnDefs={column}
            defaultColDef={defaultColDef}
            pagination={true}
            paginationPageSize={10}
            cacheBlockSize={10}
            filter= {true}
            sortable={true}
          ></AgGridReact>
        </div>
        <div className="py-2"></div>
      </div>
      <ToastContainer
        style={{ width: "50%" }}
        closeOnClick={false}
        position="top-center"
        autoClose={5000}
        hideProgressBar={true}
        newestOnTop={false}
        limit={1}
      />
    </StyledSiteDetails>
  );
}
export { SiteContext };